import { useCookies } from '@vueuse/integrations/useCookies';
import { useAppStore } from '@/stores/app.store';

export default function useLocalization(): {
  initApplicationLanguage: () => void;
  getCultureNameInCurrentCulture: (cultureCode: string) => string | undefined;
  getCultureNameInItsOwnCulture: (cultureCode: string) => string | undefined;
  changeApplicationLanguage: (cultureCode: string) => void;
} {
  const cookies = useCookies(['localhost']);
  const appStore = useAppStore();

  function initApplicationLanguage(): void {
    let cultureCode = cookies.get('culture');
    const isCultureInAvailableLanguages =
      appStore?.cultureSettings?.visibleCultures?.filter(
        (cultureObj) => cultureObj.cultureCode === cultureCode,
      ).length > 0;

    if (!isCultureInAvailableLanguages) {
      cookies.remove('culture');
    }

    if (cultureCode === undefined || cultureCode === null) {
      cultureCode = appStore?.cultureSettings?.visibleCultures?.filter(
        (cultureObj) => cultureObj.isDefault == true,
      )?.[0]?.cultureCode;
    }

    appStore.cultureCode = cultureCode;
  }
  function changeApplicationLanguage(cultureCode: string): void {
    appStore.cultureCode = cultureCode;
  }

  function getCultureNameInCurrentCulture(cultureCode: string): string | undefined {
    const culture = appStore?.cultureSettings?.visibleCultures?.find((cultureCodeItem) => {
      return cultureCodeItem?.cultureCode === cultureCode;
    });

    return culture?.cultureNameInCurrentCulture;
  }

  function getCultureNameInItsOwnCulture(cultureCode: string): string | undefined {
    const culture = appStore?.cultureSettings?.visibleCultures?.find((cultureCodeItem) => {
      return cultureCodeItem?.cultureCode === cultureCode;
    });
    return culture?.cultureNameInItsOwnCulture;
  }

  return {
    initApplicationLanguage,
    changeApplicationLanguage,
    getCultureNameInCurrentCulture,
    getCultureNameInItsOwnCulture,
  };
}
